$(document).ready(function() {

  if ($(".icons-section").length) {
    var $bindableSlider = $(".icons-section");
    var bindableSliderOptions = {
      dots: false,
      infinite: true,
      speed: 1000,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '<button type="button" aria-label="More Discounts - Previous" class="prev-button"><img src="/wp-content/uploads/2022/08/left-arrow.png" alt="Previous Button" /></button>',
      nextArrow: '<button type="button" aria-label="More Discounts - Next" class="next-button"><img src="/wp-content/uploads/2022/08/right-arrow.png" alt="Next Button" /></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    };


    $bindableSlider.slick(bindableSliderOptions);

    $(window).resize(function () {
      if ($(window).width() > breakpoints.xsmall && !$bindableSlider.hasClass('slick-initialized')) {
        $bindableSlider.slick(bindableSliderOptions);
      }
    });
  }
});